var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({staticClass:"mr-2",attrs:{"x-small":"","color":_vm.getColor()}},on),[_vm._v(" mdi-square ")])]}}])},[_vm._v(" "+_vm._s(_vm.tooltip)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }